<ng-container [formGroup]="formGroup">
  <table class="signature-provider table-striped table-no-border-bottom">
    <tr>
      <td>
        <label>Signature provider</label>
      </td>
      <td>
        <mat-select placeholder="Signature provider" formControlName="signatureProvider">
          @for (provider of signatureProviders; track provider.name) {
            <mat-option [value]="provider.name">
              {{ provider.label }}
            </mat-option>
          }
        </mat-select>
      </td>
    </tr>
  </table>
  <app-no-signature-provider
    #signatureProviderComponent
    [hidden]="signatureProvider.value !== 'none'"
  ></app-no-signature-provider>
  <table class="table-full-width table-striped">
    <tr>
      <td class="input-container-stack">
        <h2 class="heading-underline">Error notification email</h2>
        <label>Email address to receive {{ signatureProvider.value | titlecase }} envelope failure notifications for this corp</label>
        <input
          id="error-notification-email"
          class="full-width"
          type="email"
          formControlName="errorNotificationEmail"
          placeholder="e.g. docusignadmin@yourcompany.com"
        />
        @if (errorNotificationEmailControl.invalid && errorNotificationEmailControl.dirty) {
          <small class="info-tip">
            <mat-icon fontIcon="error_outline"></mat-icon>
            Enter a valid email address
          </small>
        }
      </td>
    </tr>
  </table>
  <app-signature-docusign
    #signatureProviderComponent
    [hidden]="signatureProvider.value !== 'docusign'"
  ></app-signature-docusign>
</ng-container>
